<template>
    <h2>Solicitați cotație</h2>

    <form @submit.prevent="quoteRequest">
        <div class="row form justify-content-center">
            <div class="col-12 col-sm-6">
                <div class="mb-3 tooltipstered">
                    <input v-model="form.name"
                           type="text" name="name" placeholder="Nume*" data-required="true"
                           data-valid="empty">
                </div>
                <div class="mb-3 tooltipstered">
                    <input v-model="form.company"
                           type="text" name="company" placeholder="Companie*" data-required="true"
                           data-valid="empty">
                </div>
                <div class="mb-3 tooltipstered">
                    <input v-model="form.phone"
                           type="text" name="phone" placeholder="Telefon*" data-required="true"
                            maxlength="14" data-message="Număr greșit de telefon!"
                           autocomplete="off">
                </div>
                <div class="mb-3 tooltipstered">
                    <input v-model="form.email"
                           type="text" name="email" placeholder="E-mail*" data-required="true"
                           data-valid="email" data-message="Adresă e-mail greșită!">
                </div>
            </div>
            <div class="col-12 col-sm-6 mt-3 mt-sm-0">
                <div class="mb-3 full">
                    <textarea v-model="form.description"
                              name="description" placeholder="Vă rugăm să menționația aici tipul de produs, durata și volumul solicitat."></textarea>
                </div>
            </div>
        </div>
        <div class="row form">
            <div class="col-12 col-md-10">
                <div class="mb-3">
                    <input v-model="form.agree"
                           type="checkbox" name="agree1" id="agree1"
                           value="Vreau să primesc cele mai noi informații despre backup și despre produsele Xopero">
                    <label class="form-label" for="agree1"><span class="input-checkbox"></span>
                        Vreau să primesc cele mai noi informații despre backup și despre produsele Xopero
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center mt-5">
                <div class="mb-3 modal-buttons">
                    <p>Dând click pe "Trimite" confirmați că înțelegeți
                        <a href="https://xopero.com/docs/en/personal-dp-policy.pdf" target="_blank">
                            politica de protecție de datelor
                        </a>, și
                        <a href="https://xopero.com/docs/en/information-card.pdf" target="_blank">
                            conținutul fișei informative
                        </a>.
                    </p>
                    <button type="button" class="dismiss">Anulează</button>
                    <button type="submit" class="accept">Trimite</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup>
import {reactive} from "vue";
import useQuote from "@composables/quote";
import {useToast} from "vue-toastification";

const {errors, requestXoperoOnePricing} = useQuote()
const toast = useToast()

const initialForm = {
    name: '',
    company: '',
    phone: '',
    email: '',
    description: '',
    agree: false,
}

const form = reactive({...initialForm})

const quoteRequest = async () => {
    await requestXoperoOnePricing(form)

    if (Object.keys(errors.value).length > 0) {
        toast.error('Va rugam completati toate campurile.')

        return
    }

    toast.success('Formularul a fost trimis.')
    Object.assign(form, initialForm)
}
</script>

<style scoped>

</style>
